export const APP_Version = "1.2";
export const IS_AUTH_ENABLED = 'Y';
export const SERVICE_URL = '';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_INSTANCE_ID = 'SET_INSTANCE_ID';

export const SET_DPHOST_URL = 'SET_DPHOST_URL';
export const SET_APPLET_URL = 'SET_APPLET_URL';

export const SET_RDS_URLS = 'SET_RDS_URLS';
export const SET_MODEL = 'SET_MODEL';
export const SET_USER_ROLES = 'SET_USER_ROLES';
export const RESET_COMPONENT = 'RESET_COMPONENT';

export const RELOAD_PAGE_EXCEUTION_COUNT=5;
export const RELOAD_PAGE_EXCEUTION_DURATION=10000;

